export default __webpack_public_path__ + "static/media/wheel-banner.90e4a7e7.gif";